








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ApiPermissions } from '@/core/security/Permissions';
import { RealmApi } from '@/services/api/api.realms';
import { RestartRealmRequest, Realm } from '@/types/apiServerContract';

@Component
export default class RestartServer extends Vue {
	@Prop() realm!: Realm;

	permissions: string[] = [ApiPermissions.Realm.RestartRealm];

	request: RestartRealmRequest = {
	    delay: 30,
	    hardReset: false,
	    message: ''
	};

	loading: boolean = false;

	async RestartRealm() {
	    const check = await this.$bvModal.msgBoxConfirm(`Are you sure you wish to ${this.request.hardReset ? 'hard reset' : 'restart'} the server?`, {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    try {
	        this.loading = true;
	        const response = await RealmApi.RestartRealm(this.request);

	        this.$bvToast.toast(response.message, {
	            variant: 'success',
	            title: 'Success'
	        });
	    } finally {
	        this.loading = false;
	    }

	    this.Reset();
	}

	Reset() {
	    this.request = {
	        delay: 30,
	        hardReset: false,
	        message: ''
	    };
	    this.$nextTick(() => {
	        (this.$refs.Validator as any).reset();
	    });
	}
}
